// ── SEO Landing Page Data ─────────────────────────────────────────────────────

export const THEMES = [
  {
    slug: 'dinosaurs', label: 'Dinosaurs', emoji: '🦕',
    description: 'Roaring adventures with friendly dinosaurs your child will love.',
    whyKidsLove: "Dinosaur stories ignite a child's natural curiosity about the ancient world. From roaring T-Rexes to gentle giants, these tales blend prehistoric wonder with modern values — bravery, friendship, and kindness. Every child secretly believes they could befriend a dinosaur, and these stories let them try.",
    storyTitles: [
      'The Friendly T-Rex Who Was Afraid of the Dark',
      'When the Last Dinosaur Egg Finally Hatched',
      'The Little Triceratops Who Saved the Valley',
      'Roar! The Dinosaur Who Learned to Be Gentle',
    ],
    facts: [
      'There were over 700 different species of dinosaurs roaming the Earth',
      'Some dinosaurs were actually smaller than a modern-day chicken',
      'The word "dinosaur" means "terrible lizard" in Ancient Greek',
    ],
  },
  {
    slug: 'superheroes', label: 'Superheroes', emoji: '🦸',
    description: 'Heroic tales where your child saves the day with courage and kindness.',
    whyKidsLove: "Superhero stories give children permission to dream big and believe in themselves. They show that real superpowers aren't about flying or strength — they're about kindness, courage, and standing up for what's right. Every child has a hero inside them waiting to emerge.",
    storyTitles: [
      'The Night the City Needed the Smallest Hero',
      'Captain Kindness and the Playground Bully',
      'The Superhero Who Was Afraid of Thunderstorms',
      'When Two Heroes Learn to Share Their Powers',
    ],
    facts: [
      'Studies show children who imagine themselves as heroes show greater resilience and confidence',
      'The first comic book superhero appeared in print back in 1938',
      'Every great hero has a weakness — it\'s what makes them relatable and human',
    ],
  },
  {
    slug: 'space', label: 'Space', emoji: '🚀',
    description: 'Magical journeys through the stars, planets, and galaxies far away.',
    whyKidsLove: "Space stories unlock a child's sense of wonder about the universe. From twinkling stars to distant planets, these adventures help children grasp how vast and magical the world beyond our sky truly is — while always finding their way safely home.",
    storyTitles: [
      'The Star That Fell Into the Garden',
      'Captain Luna and the Lost Planet',
      'The Little Astronaut Who Found a Baby Alien',
      'When the Moon Came Down to Play',
    ],
    facts: [
      'There are more stars in the universe than grains of sand on all of Earth\'s beaches combined',
      'A day on Venus is longer than a year on Venus — it spins that slowly',
      'The Moon is slowly moving away from Earth — about 3.8 centimetres per year',
    ],
  },
  {
    slug: 'unicorns', label: 'Unicorns', emoji: '🦄',
    description: 'Enchanting stories filled with magic, rainbows, and mythical creatures.',
    whyKidsLove: 'Unicorn stories are pure magic — shimmering with colour, wonder, and endless possibility. They help children explore themes of kindness, belonging, and believing in things you cannot always see. Perfect for dreamers of all ages who know that magic is real if you look closely enough.',
    storyTitles: [
      'The Unicorn Who Lost Her Horn',
      'Rainbow Valley and the Lonely Unicorn',
      'The Last Unicorn Foal in the Enchanted Forest',
      'When Unicorns and Dragons Became Best Friends',
    ],
    facts: [
      'Unicorns appear in ancient legends from Greece, China, and the Middle East',
      'A group of unicorns is officially called a "blessing"',
      'The unicorn is the national animal of Scotland — it represents purity and power',
    ],
  },
  {
    slug: 'dragons', label: 'Dragons', emoji: '🐉',
    description: 'Brave adventures with friendly dragons in magical kingdoms.',
    whyKidsLove: "Dragon stories captivate children with the idea that something fearsome can also be gentle and loving. They explore the beauty in difference — showing that the most misunderstood creatures often have the kindest hearts and the most surprising friendships to offer.",
    storyTitles: [
      'The Tiny Dragon Who Couldn\'t Breathe Fire',
      'The Dragon Who Collected Colouring Books',
      'Why the Mountain Dragon Learned to Cry',
      'The Dragon and the Child Who Weren\'t Afraid',
    ],
    facts: [
      'Dragons appear in the mythology of nearly every major culture on Earth',
      'In Chinese culture, dragons are symbols of good luck, wisdom, and power',
      'The word "dragon" comes from the Greek word "drakōn" meaning "great serpent"',
    ],
  },
  {
    slug: 'mermaids', label: 'Mermaids', emoji: '🧜',
    description: 'Underwater adventures in the deep blue sea with magical sea creatures.',
    whyKidsLove: "Mermaid stories take children on a journey beneath the waves into a world of colour, wonder, and mystery. They explore themes of curiosity, belonging between two worlds, and the courage to be different — lessons every child carries long after the story ends.",
    storyTitles: [
      'The Mermaid Who Wanted to Climb Trees',
      'Deep Blue: A Mystery Under the Sea',
      'The Mermaid Princess and the Talking Seahorse',
      'When the Ocean Went Quiet',
    ],
    facts: [
      'Mermaid legends date back over 3,000 years to ancient Assyria',
      'Christopher Columbus reportedly spotted "mermaids" on his voyage — they were actually manatees',
      'In Scottish folklore, mermaids called "selkies" could transform into humans on land',
    ],
  },
  {
    slug: 'animals', label: 'Animals', emoji: '🐾',
    description: "Heartwarming tales featuring your child's favourite animals.",
    whyKidsLove: "Animal stories help children develop empathy and compassion by seeing the world through another creature's eyes. Whether it's a brave little mouse or a gentle elephant, animal tales show that size never determines the size of your heart.",
    storyTitles: [
      'The Mouse Who Roared Louder Than a Lion',
      'The Elephant Who Never Forgot a Friend',
      'Why the Fox and the Rabbit Became Best Friends',
      'The Tiny Hedgehog Who Crossed the Big Road',
    ],
    facts: [
      'Dogs can understand up to 250 words and gestures — about the same as a 2-year-old child',
      'Elephants are one of the few animals that recognise themselves in a mirror, just like humans',
      'Crows are so intelligent they can remember individual human faces for years',
    ],
  },
  {
    slug: 'fairies', label: 'Fairies', emoji: '🧚',
    description: 'Magical fairy tales in enchanted forests full of wonder.',
    whyKidsLove: "Fairy stories are windows into a miniature world of magic hidden just out of sight. They spark a child's imagination and teach them to look more closely at the world around them — because magic might be hiding in the garden, under a mushroom, or inside a raindrop.",
    storyTitles: [
      'The Fairy Who Was Afraid of Flowers',
      'Dewdrop and the Lost Spell Book',
      'The Night the Fairies Fixed the Moon',
      'Petal\'s First Wings: A Coming-of-Age Fairy Story',
    ],
    facts: [
      'Fairy tales have been told for at least 4,000 years — some scholars believe much longer',
      'In Irish folklore, leaving a bowl of cream outside overnight was said to keep the fairies happy',
      'The word "fairy" comes from the Latin word "fata" meaning "fate"',
    ],
  },
  {
    slug: 'pirates', label: 'Pirates', emoji: '🏴‍☠️',
    description: 'High-seas adventures hunting for treasure with a friendly crew.',
    whyKidsLove: "Pirate stories tap into a child's love of adventure, freedom, and treasure hunts. But the best pirate stories also show that the greatest treasure of all is always the friends you make along the way — and the courage you discover inside yourself.",
    storyTitles: [
      'Captain Tiny and the Map That Glowed in the Dark',
      'The Pirate Ship That Could Talk',
      'X Marks the Spot — But the Treasure Was Friendship',
      'The Kindest Pirate Who Ever Sailed the Seven Seas',
    ],
    facts: [
      'Real pirates of the golden age (1650–1730) had a strict code of conduct and rules aboard their ships',
      '"Jolly Roger" — the famous skull flag — may have come from French "jolie rouge" meaning "pretty red"',
      'Parrots were popular pirate companions because they could be sold for very high prices in European ports',
    ],
  },
  {
    slug: 'robots', label: 'Robots', emoji: '🤖',
    description: 'Futuristic adventures with friendly robots and amazing gadgets.',
    whyKidsLove: "Robot stories help children explore big questions about feelings, friendship, and what it means to be human — through the eyes of a machine trying to understand the world. They blend technology with heart in a way children find endlessly fascinating.",
    storyTitles: [
      'The Robot Who Learned to Feel',
      'Bolt and the Boy Who Built Him',
      'The Last Robot in the Universe',
      'When the Factory Robot Started Painting Pictures',
    ],
    facts: [
      'The word "robot" was first used in 1920 in a Czech play about artificial workers',
      'Japan has more working robots per capita than any other country in the world',
      'Scientists are now teaching robots to learn from mistakes — just like children do',
    ],
  },
  {
    slug: 'princesses', label: 'Princesses', emoji: '👸',
    description: 'Royal adventures where brave princesses solve problems with kindness.',
    whyKidsLove: "Modern princess stories celebrate courage, intelligence, and kindness over beauty or waiting to be rescued. Today's princess is the hero of her own story — solving problems, making friends, and leading with her heart rather than waiting for anyone to save her.",
    storyTitles: [
      'Princess Nova and the Dragon She Made Friends With',
      'The Princess Who Refused the Glass Slipper',
      'The Night the Princess Saved the Kingdom Herself',
      'Queen of Kindness: A Story About Real Royalty',
    ],
    facts: [
      'The oldest known fairy tale about a princess is over 4,000 years old',
      'In many ancient cultures, princesses were educated in science, philosophy, mathematics, and politics',
      '"Princess" comes from the Latin "princeps" meaning "first citizen" — not "most beautiful"',
    ],
  },
  {
    slug: 'jungle', label: 'Jungle', emoji: '🌿',
    description: 'Wild adventures deep in the jungle with exotic animals and plants.',
    whyKidsLove: "Jungle stories are bursting with life, colour, and discovery. They inspire a love of nature and the natural world — teaching children about ecosystems, incredible animals, and the importance of protecting the wild places that make our planet extraordinary.",
    storyTitles: [
      'The Monkey Who Couldn\'t Climb',
      'Lost in the Jungle and Found by a Jaguar',
      'The Night the Jungle Went Quiet',
      'Treehouse Kingdom: Adventures in the Canopy',
    ],
    facts: [
      'Tropical rainforests cover only 6% of Earth\'s surface but contain over half of all plant and animal species',
      'The Amazon rainforest produces approximately 20% of the world\'s oxygen',
      'Some jungle plants only flower once every 100 years — then they die after blooming',
    ],
  },
  {
    slug: 'ocean', label: 'Ocean', emoji: '🌊',
    description: 'Deep sea adventures exploring coral reefs and ocean creatures.',
    whyKidsLove: "Ocean stories open up a world that covers 71% of our planet but remains largely unexplored. They teach children about incredible marine life, the importance of protecting our seas, and the thrill of discovery in the deep blue unknown that hides more secrets than outer space.",
    storyTitles: [
      'The Seahorse Who Wanted to Race',
      'What Lives at the Very Bottom of the Sea',
      'The Whale Song That Saved the Ocean',
      'Coral Kingdom: A Deep-Sea Adventure',
    ],
    facts: [
      'More than 80% of the ocean has never been explored or mapped by humans',
      'The deepest point in the ocean — the Mariana Trench — is deeper than Mount Everest is tall',
      'Scientists discover approximately 2,000 new ocean species every single year',
    ],
  },
  {
    slug: 'magic', label: 'Magic', emoji: '✨',
    description: 'Spellbinding stories full of magical spells, potions, and wizards.',
    whyKidsLove: "Magic stories create a sense that the world is bigger, stranger, and more wonderful than it appears. They teach children to look beyond the obvious — and to believe that with enough imagination, the impossible becomes possible and the ordinary becomes extraordinary.",
    storyTitles: [
      'The Spell That Went Perfectly Wrong',
      'The Magic Library Where Books Come Alive',
      'Apprentice: A Young Wizard\'s Very First Spell',
      'The Wand That Only Worked for Kind Hearts',
    ],
    facts: [
      'The idea of magic wands dates back to ancient Egypt — over 4,000 years ago',
      'In many cultures, certain trees were believed to have magical properties — oak, ash, and thorn especially',
      'The word "abracadabra" was first written as a magic healing spell in ancient Rome',
    ],
  },
  {
    slug: 'trains', label: 'Trains', emoji: '🚂',
    description: 'Exciting railway adventures across mountains, tunnels and bridges.',
    whyKidsLove: "Train stories capture the romance of travel and the excitement of going somewhere new. The rhythm of wheels on tracks, the mystery of what lies at the next station, and the fascinating people you meet along the way make for endlessly magical adventures your child will ask for again and again.",
    storyTitles: [
      'The Midnight Train to Anywhere You Want',
      'The Little Engine Who Didn\'t Know Where She Was Going',
      'Last Stop: The Town at the Edge of the World',
      'The Train Driver Who Could Talk to Animals',
    ],
    facts: [
      'The first steam-powered passenger locomotive began service in 1825 in England',
      'The world\'s longest non-stop train journey covers 9,289 km — from Moscow to Vladivostok',
      'Japan\'s Shinkansen bullet trains travel at over 300 km/h and arrive late less than 1% of the time',
    ],
  },
  {
    slug: 'sports', label: 'Sports', emoji: '⚽',
    description: 'Inspiring stories about teamwork, perseverance, and sportsmanship.',
    whyKidsLove: "Sports stories inspire children to push themselves, work as a team, and never give up — even when things get hard. They show that winning isn't everything; the courage to try and keep going is always more important and more admirable than the final score.",
    storyTitles: [
      'The Goalkeeper Who Was Afraid of the Ball',
      'Last Pick: The Kid Nobody Wanted on Their Team',
      'The Race Nobody Expected Her to Win',
      'When the Whole Team Came Last — and Still Won',
    ],
    facts: [
      'Regular physical activity in childhood is directly linked to better focus and academic performance',
      'The Olympic Games date back to 776 BC in ancient Greece',
      'Children who play team sports develop stronger social skills and deeper friendships than those who don\'t',
    ],
  },
  {
    slug: 'cooking', label: 'Cooking', emoji: '👨‍🍳',
    description: 'Delicious adventures in the kitchen with magical recipes and ingredients.',
    whyKidsLove: "Cooking stories bring all the senses into the adventure — the sizzle, the smell, the taste of something made with love. They show children that creating food for others is one of the most joyful and generous things you can do, and that every great chef started with one small recipe.",
    storyTitles: [
      'The Magical Bakery Where Cakes Granted Wishes',
      'Chef Junior and the Secret Family Recipe',
      'The Night the Kitchen Came Alive',
      'The Soup That Could Cure Absolutely Anything',
    ],
    facts: [
      'Cooking is one of the most effective ways to teach children maths — measuring, timing, and fractions',
      'Children who help with cooking are significantly more likely to eat vegetables they\'ve prepared themselves',
      'The oldest known recipe ever discovered is over 3,700 years old — and it\'s a recipe for beer',
    ],
  },
  {
    slug: 'friendship', label: 'Friendship', emoji: '🤝',
    description: 'Beautiful stories about the power of true friendship and kindness.',
    whyKidsLove: "Friendship stories are among the most emotionally powerful a child can experience. They validate the feelings of loneliness, the joy of connection, and the bravery it takes to say hello to someone new — lessons that stay with children far longer than any facts they learn at school.",
    storyTitles: [
      'The New Kid Who Didn\'t Know How to Make Friends',
      'Two Very Different Children Who Became Best Friends',
      'The Friend Who Moved Far Away',
      'When Best Friends Completely Disagree',
    ],
    facts: [
      'Research shows children with at least one strong friendship are measurably more resilient under stress',
      'Friendships formed in early childhood are among the most formative experiences in a person\'s life',
      'Acts of kindness make both the giver and the receiver happier — this has been proven by science',
    ],
  },
  {
    slug: 'adventure', label: 'Adventure', emoji: '🗺️',
    description: 'Epic quests and exciting journeys to discover hidden treasures.',
    whyKidsLove: "Adventure stories awaken the explorer in every child. They teach problem-solving, resilience, and the quiet confidence that comes from facing the unknown and discovering you are capable of far more than you ever thought — one step at a time.",
    storyTitles: [
      'The Map That Wasn\'t on Any Map',
      'Into the Forest Nobody Had Come Back From — Until Now',
      'The Quest for the Golden Something-or-Other',
      'Three Kids, No Adults, and a Very Strange Island',
    ],
    facts: [
      'Children who engage regularly with adventurous stories show higher levels of creative and lateral thinking',
      'The oldest adventure story in the world — The Epic of Gilgamesh — is over 4,000 years old',
      'Exploration is hardwired into the human brain — it\'s why children are naturally drawn to maps and hidden places',
    ],
  },
  {
    slug: 'halloween', label: 'Halloween', emoji: '🎃',
    description: 'Not-too-scary Halloween tales with friendly ghosts and magical pumpkins.',
    whyKidsLove: "Halloween stories let children explore the thrill of being a little bit scared — completely safely. They show that the monster under the bed just wants a friend, the ghost in the hallway is simply lost, and that bravery is always more powerful than any fear.",
    storyTitles: [
      'The Ghost Who Was Afraid of Children',
      'The Pumpkin Who Glowed for the Very First Time',
      'Not-So-Spooky: A Halloween Story for Brave Little Ones',
      'The Witch Who Forgot How to Be Scary',
    ],
    facts: [
      'Halloween dates back over 2,000 years to the ancient Celtic festival of Samhain',
      'Pumpkins were not the original Jack-o-lanterns — the Irish traditionally carved turnips',
      'In Mexico, Día de los Muertos is a joyful, colourful celebration of loved ones who have passed away',
    ],
  },
  {
    slug: 'christmas', label: 'Christmas', emoji: '🎄',
    description: 'Magical Christmas stories full of wonder, gifts, and holiday spirit.',
    whyKidsLove: "Christmas stories are filled with the magic of giving, the warmth of family, and the wonder of believing in something you cannot see. They remind children — and adults — that kindness and generosity are the greatest gifts of all, and that Christmas magic lives in the heart.",
    storyTitles: [
      'The Elf Who Wanted to Be a Toy Maker',
      'The Reindeer Who Couldn\'t Fly',
      'Christmas Eve at the Very Top of the World',
      'The Year Santa\'s Sleigh Broke Down',
    ],
    facts: [
      '"Jingle Bells" was originally written for Thanksgiving — not Christmas',
      'The tradition of hanging stockings by the fireplace dates back to a legend about St. Nicholas',
      'In Iceland, children receive books on Christmas Eve — a tradition called Jólabókaflóð, the "Christmas Book Flood"',
    ],
  },
];

export const LANGUAGES = [
  {
    slug: 'english', label: 'English', code: 'en', native: 'English', emoji: '🇬🇧',
    culturalNote: "English bedtime storytelling has a rich tradition stretching back centuries — from Beatrix Potter's tales of Peter Rabbit to A.A. Milne's Winnie-the-Pooh. Reading to children in English builds vocabulary, comprehension, and a lifelong love of language that no classroom can fully replicate.",
    bilingualBenefit: 'English is spoken by over 1.5 billion people worldwide, making it one of the most valuable languages for your child\'s future. A strong foundation in English reading opens doors to education, opportunity, and connection across every continent.',
    storyTitles: ['The Garden Where Words Grow', 'The Library at the End of the Rainbow', 'English Adventures: Around the World in 80 Stories'],
    facts: [
      'English has the largest vocabulary of any language — over 170,000 words currently in active use',
      'Shakespeare personally invented over 1,700 words that we still use in everyday English today',
      'Children read to for 20 minutes a day are exposed to 1.8 million words per year',
    ],
  },
  {
    slug: 'spanish', label: 'Spanish', code: 'es', native: 'Español', emoji: '🇪🇸',
    culturalNote: "La hora del cuento — story time — is a beloved tradition in Spanish-speaking families across Spain, Mexico, Colombia, Argentina, and 18 other countries. Bedtime stories in Spanish connect children to a rich, vibrant culture shared by over 500 million people worldwide.",
    bilingualBenefit: 'Spanish is the second most spoken native language in the world and growing rapidly. Children who learn Spanish early develop stronger cognitive flexibility, and research consistently shows bilingual Spanish-English children have better problem-solving skills and greater cultural empathy.',
    storyTitles: ['El Dragón que Quería Ser Cocinero', 'La Niña que Habló con las Estrellas', 'Aventuras en el Bosque Mágico'],
    facts: [
      'Spanish is spoken in 21 countries as an official language — the most of any language after English',
      'Spanish is now the second most spoken language in the United States and growing every year',
      'Children learning Spanish alongside English show improved literacy skills in both languages simultaneously',
    ],
  },
  {
    slug: 'french', label: 'French', code: 'fr', native: 'Français', emoji: '🇫🇷',
    culturalNote: "France has one of the world's richest children's literary traditions — from Le Petit Prince to Babar the Elephant. Bedtime stories in French (\"les histoires du soir\") are a cherished ritual in French families, often passed down through generations with great care and warmth.",
    bilingualBenefit: 'French is spoken on five continents and is the official language of 29 countries. Early French reading builds a foundation for understanding other European languages, culture, and history — and gives children a distinct lifetime advantage in international careers.',
    storyTitles: ['La Petite Étoile Perdue', 'Le Chat Qui Voulait Voir Paris', "L'Aventure au Bord de la Mer"],
    facts: [
      'French is one of the official languages of the United Nations, the European Union, and the Olympic Games',
      'Over 300 million people speak French worldwide across 5 continents',
      'Learning French has been shown to measurably improve children\'s English grammar and vocabulary',
    ],
  },
  {
    slug: 'hindi', label: 'Hindi', code: 'hi', native: 'हिन्दी', emoji: '🇮🇳',
    culturalNote: "Indian bedtime storytelling is one of the oldest traditions in the world. The Panchatantra — a collection of ancient Indian animal fables — is over 2,000 years old and has been translated into more languages than any book except the Bible. Stories in Hindi connect children to this extraordinary heritage.",
    bilingualBenefit: 'Hindi is spoken by over 600 million people and is one of the most widely spoken languages on Earth. For Indian families around the world, reading bedtime stories in Hindi keeps children connected to their roots, culture, and extended family — no matter how far from home they live.',
    storyTitles: ['तारों की रानी', 'जादुई जंगल का रहस्य', 'बहादुर बच्चे की कहानी'],
    facts: [
      'The Panchatantra, written in Sanskrit and later translated to Hindi, is the world\'s oldest collection of children\'s stories',
      'Hindi has influenced hundreds of English words — including jungle, bungalow, shampoo, pyjamas, and avatar',
      'Hindi is written in the beautiful Devanagari script, which is also used for Sanskrit, Marathi, and Nepali',
    ],
  },
  {
    slug: 'german', label: 'German', code: 'de', native: 'Deutsch', emoji: '🇩🇪',
    culturalNote: "Germany gave the world some of the most beloved children's stories ever written. The Brothers Grimm — Jacob and Wilhelm — collected and published their famous fairy tales in 1812, including Cinderella, Snow White, and Hansel and Gretel. Reading in German connects children to this extraordinary storytelling heritage.",
    bilingualBenefit: 'German is spoken by over 100 million people and is the most widely spoken native language in Europe. Children who read German develop strong analytical thinking skills — research consistently links German language learning to higher mathematical aptitude and logical reasoning.',
    storyTitles: ['Das Kleine Drachenkind', 'Die Nacht, als die Sterne Tanzten', 'Der Zauberladen am Ende der Straße'],
    facts: [
      'The Brothers Grimm collected over 200 fairy tales that are still read by children worldwide today',
      'German has over 3 million words — one of the largest vocabularies of any language on Earth',
      'Children who learn German score significantly higher in spatial reasoning and logical thinking tests',
    ],
  },
  {
    slug: 'portuguese', label: 'Portuguese', code: 'pt', native: 'Português', emoji: '🇧🇷',
    culturalNote: "Portuguese storytelling spans two great literary cultures — Portugal and Brazil — each with its own magical flavour. From the mystical legends of Portugal's Atlantic coast to Brazil's rich Amazonian folklore, stories in Portuguese connect children to one of the most culturally diverse languages on Earth.",
    bilingualBenefit: 'Portuguese is spoken by over 250 million people across 10 countries, making it one of the top 5 most spoken languages in the world. For Brazilian and Portuguese families abroad, bedtime stories in Portuguese keep children connected to their culture, family, and heritage in the most natural way.',
    storyTitles: ['A Menina e o Boto Cor-de-Rosa', 'O Menino que Falava com os Pássaros', 'A Floresta Encantada do Brasil'],
    facts: [
      'Portuguese is spoken on every continent and is an official language in 10 countries worldwide',
      'Brazilian Portuguese and European Portuguese differ similarly to American and British English',
      'The Livraria Bertrand in Lisbon, Portugal, opened in 1732 — making it the world\'s oldest operating bookshop',
    ],
  },
  {
    slug: 'arabic', label: 'Arabic', code: 'ar', native: 'العربية', emoji: '🇸🇦',
    culturalNote: "Arabic has one of the world's greatest storytelling traditions. One Thousand and One Nights — also known as Arabian Nights — is a collection of Arabic folk tales that has captivated readers for over 1,000 years. Stories in Arabic connect children to a rich culture of wisdom, poetry, and timeless adventure.",
    bilingualBenefit: 'Arabic is spoken by over 400 million people and is one of the six official languages of the United Nations. For Arab families around the world, bedtime stories in Arabic preserve language, cultural identity, and family connection — especially for children growing up in English-speaking countries.',
    storyTitles: ['ليلة النجوم المضيئة', 'الأمير الصغير والتنين الطيب', 'مغامرة في الصحراء الساحرة'],
    facts: [
      'Arabic is written right to left and has 28 letters — each letter changes shape depending on where it appears',
      'Arabic has given English hundreds of words — including algebra, alcohol, candy, cotton, and magazine',
      'One Thousand and One Nights has been translated into virtually every major language in the world',
    ],
  },
  {
    slug: 'chinese', label: 'Chinese', code: 'zh', native: '中文', emoji: '🇨🇳',
    culturalNote: "Chinese storytelling is among the world's oldest — with myths, legends, and folk tales stretching back thousands of years. Stories of the Jade Emperor, the Moon Goddess Chang'e, and the Monkey King have been told at Chinese bedsides for generations, connecting children to one of humanity's greatest cultural heritages.",
    bilingualBenefit: 'Mandarin Chinese is spoken by over 1 billion people and is the most widely spoken first language in the world. Research consistently shows that children who learn Chinese develop exceptional memory, concentration, and mathematical ability — making it one of the most valuable languages to learn early in life.',
    storyTitles: ['月亮姐姐的故事', '小龙的大冒险', '星星和太阳的秘密'],
    facts: [
      'Chinese is the oldest continuously used writing system in the world — over 4,000 years old',
      'The Chinese New Year legend of Nian is one of the world\'s most widely celebrated folk tales',
      'Children learning to read Chinese develop exceptional visual memory and pattern recognition skills',
    ],
  },
  {
    slug: 'japanese', label: 'Japanese', code: 'ja', native: '日本語', emoji: '🇯🇵',
    culturalNote: "Japan has a deeply cherished tradition of bedtime storytelling. Classics like Momotarō (Peach Boy), Kaguya-hime (The Bamboo Princess), and Urashima Tarō have been told to Japanese children for over a thousand years. Stories in Japanese connect children to one of the world's most beautiful and distinctive cultures.",
    bilingualBenefit: 'Japanese is spoken by 125 million people and is one of the most important languages in technology, art, and global business. Children who learn Japanese develop exceptional attention to detail and patience — and gain access to a rich, unique world of art, culture, and creative expression.',
    storyTitles: ['桃太郎の新しい冒険', 'お月様と小さな子ども', '魔法の森の秘密'],
    facts: [
      'Japanese has three writing systems — Hiragana, Katakana, and Kanji — often used together in a single sentence',
      'The Japanese story of Momotarō (Peach Boy) is over 500 years old and remains one of Japan\'s most beloved children\'s tales',
      'Japan publishes more books per person than almost any other country in the world',
    ],
  },
  {
    slug: 'italian', label: 'Italian', code: 'it', native: 'Italiano', emoji: '🇮🇹',
    culturalNote: "Italy has given the world some of its most beloved children's stories. Pinocchio, written by Carlo Collodi in 1883, is one of the most translated books in history. Reading in Italian connects children to a culture of art, food, family, and extraordinary storytelling that stretches back to the Renaissance.",
    bilingualBenefit: 'Italian is spoken by 85 million people and is the closest living language to Latin. Children who learn Italian build a strong foundation for understanding Spanish, French, Portuguese, and Romanian — making it one of the most linguistically valuable languages to learn in early childhood.',
    storyTitles: ['Il Bambino che Parlava con le Stelle', 'La Principessa della Luna', 'Il Drago Buono di Venezia'],
    facts: [
      'Pinocchio, written in Italian by Carlo Collodi in 1883, has been translated into over 260 languages worldwide',
      'Italian is considered the language of music — most musical terms (piano, forte, allegro, crescendo) are Italian words',
      'The Italian bedtime fable tradition "favole della buonanotte" dates back to ancient Roman times',
    ],
  },
  {
    slug: 'gujarati', label: 'Gujarati', code: 'gu', native: 'ગુજરાતી', emoji: '🇮🇳',
    culturalNote: "Gujarati storytelling is a rich oral tradition passed down through generations. Folk tales of brave kings, clever animals, and magical forests from the Gujarat region have been told at bedtime for centuries. Stories in Gujarati connect children to a vibrant culture known for its warmth, entrepreneurial spirit, and deep community values.",
    bilingualBenefit: 'Gujarati is spoken by over 60 million people worldwide, with significant communities in the UK, USA, Canada, East Africa, and Australia. For Gujarati families abroad, bedtime stories in Gujarati are one of the most powerful ways to keep children connected to their language, culture, and family roots.',
    storyTitles: ['ચંદ્ર અને તારાઓની વાર્તા', 'જાદુઈ જંગલનો રાજા', 'નાનકડા હીરોની કહાની'],
    facts: [
      'Gujarati has been spoken for over 700 years and has a rich literary and poetic tradition',
      'Mahatma Gandhi\'s mother tongue was Gujarati — he was born in Porbandar, Gujarat',
      'Gujarati communities have settled in over 100 countries, making it one of the world\'s most globally distributed languages',
    ],
  },
];

export const AGE_GROUPS = [
  { slug: 'toddlers', label: 'Toddlers',  range: '1–3',  emoji: '👶', description: 'Simple, soothing stories with repetition and gentle lessons perfect for little ones aged 1 to 3.' },
  { slug: 'age-3-5',  label: 'Ages 3–5',  range: '3–5',  emoji: '🧒', description: 'Short, imaginative stories with vivid characters and simple morals for preschool children.' },
  { slug: 'age-5-7',  label: 'Ages 5–7',  range: '5–7',  emoji: '📚', description: 'Engaging adventures with fun characters and meaningful lessons for early school-age children.' },
  { slug: 'age-7-9',  label: 'Ages 7–9',  range: '7–9',  emoji: '🌟', description: 'Longer, more complex stories with exciting plots and deeper themes for growing readers.' },
  { slug: 'age-9-12', label: 'Ages 9–12', range: '9–12', emoji: '🏆', description: 'Rich, chapter-style stories with advanced vocabulary and sophisticated themes for tweens.' },
];

export const OCCASIONS = [
  { slug: 'first-day-of-school', label: 'First Day of School', emoji: '🎒', description: 'Help ease first-day nerves with a personalised story about starting school with confidence.' },
  { slug: 'new-baby-sibling',    label: 'New Baby Sibling',    emoji: '👶', description: 'Gentle stories to help your child welcome and bond with their new baby brother or sister.' },
  { slug: 'moving-house',        label: 'Moving House',        emoji: '🏠', description: 'Reassuring stories to help children embrace the excitement of moving to a new home.' },
  { slug: 'birthday',            label: 'Birthday',            emoji: '🎂', description: 'Make their special day even more magical with a story where they are the birthday hero.' },
  { slug: 'potty-training',      label: 'Potty Training',      emoji: '🚽', description: 'Fun, encouraging stories to make potty training a positive and exciting adventure.' },
  { slug: 'fear-of-dark',        label: 'Fear of the Dark',    emoji: '🌙', description: 'Comforting stories that gently help children overcome their fear of the dark at bedtime.' },
  { slug: 'losing-a-pet',        label: 'Losing a Pet',        emoji: '🐾', description: 'Tender, healing stories to help children process the loss of a beloved pet with love.' },
  { slug: 'making-friends',      label: 'Making Friends',      emoji: '🤝', description: 'Encouraging stories about making new friends, being kind, and fitting in at school.' },
  { slug: 'parents-travelling',  label: 'Parent Travelling',   emoji: '✈️', description: 'Reassuring stories for when mum or dad is away, reminding children they are always loved.' },
  { slug: 'starting-nursery',    label: 'Starting Nursery',    emoji: '🌈', description: 'Warm, gentle stories to ease the transition into nursery or daycare with excitement.' },
];

export const POPULAR_NAMES = [
  'Emma', 'Liam', 'Olivia', 'Noah', 'Ava', 'Oliver', 'Isabella', 'Elijah',
  'Sophia', 'James', 'Mia', 'Aiden', 'Charlotte', 'Lucas', 'Amelia', 'Mason',
  'Harper', 'Ethan', 'Evelyn', 'Logan', 'Luna', 'Jackson', 'Aria', 'Sebastian',
  'Chloe', 'Mateo', 'Penelope', 'Jack', 'Layla', 'Owen', 'Riley', 'Theodore',
  'Zoey', 'Asher', 'Nora', 'Henry', 'Lily', 'Alexander', 'Eleanor', 'Daniel',
  'Hannah', 'William', 'Lillian', 'Benjamin', 'Addison', 'Elias', 'Aubrey',
  'Samuel', 'Ellie', 'David', 'Stella', 'Joseph', 'Natalie', 'Carter', 'Zoe',
  'Wyatt', 'Hazel', 'John', 'Violet', 'Luke', 'Aurora', 'Gabriel', 'Savannah',
  'Anthony', 'Audrey', 'Isaac', 'Brooklyn', 'Dylan', 'Bella', 'Leo', 'Claire',
  'Lincoln', 'Skylar', 'Jaxon', 'Lucy', 'Levi', 'Paisley', 'Christopher', 'Everly',
  'Joshua', 'Anna', 'Andrew', 'Caroline', 'Ryan', 'Genesis', 'Nathan', 'Aaliyah',
  'Caleb', 'Kennedy', 'Thomas', 'Kinsley', 'Amir', 'Priya', 'Arjun', 'Ananya',
  'Rohan', 'Diya', 'Aarav', 'Ishaan', 'Sofia', 'Matteo', 'Giulia', 'Marco',
  'Hugo', 'Camille', 'Louis', 'Fatima', 'Yusuf', 'Zara', 'Omar', 'Yasmin', 'Adam',
  // Girls — expanded list
  'Abigail', 'Grace', 'Sophie', 'Cora', 'Mila', 'Isla', 'Piper', 'Naomi', 'Ruby',
  'Scarlett', 'Willow', 'Maya', 'Iris', 'Jade', 'Jasmine', 'Leah', 'Paige', 'Peyton',
  'Sadie', 'Summer', 'Tessa', 'Vera', 'Victoria', 'Wren', 'Amber', 'Brooke', 'Diana',
  'Eden', 'Faith', 'Fiona', 'Georgia', 'Holly', 'Hope', 'Ivy', 'Laura', 'Lexi',
  'Madison', 'Maria', 'Morgan', 'Nicole', 'Rachel', 'Rebecca', 'Rose', 'Sara', 'Serena',
  'Taylor', 'Vivian', 'Felicity', 'Imogen', 'Harriet', 'Maeve', 'Sienna', 'Phoebe',
  'Arabella', 'Cecilia', 'Rosalie', 'Miriam', 'Beatrice', 'Valentina', 'Camila',
  'Lucia', 'Carmen', 'Francesca', 'Chiara', 'Kavya', 'Saanvi', 'Meera', 'Navya',
  'Riya', 'Tanvi', 'Aditi', 'Aisha', 'Zainab', 'Mariam', 'Nour', 'Rania', 'Amira',
  'Nadia', 'Sana', 'Myra', 'Kiara', 'Veda', 'Cleo', 'Nell', 'Frida', 'Bianca',
  'Lena', 'Nina', 'Lydia', 'Delilah', 'Clara', 'Autumn', 'Freya', 'Thea', 'Astrid',
  'Margot', 'Aanya', 'Hana', 'Elspeth', 'Ottilie', 'Perdita', 'Clementine',
  // Boys — expanded list
  'Aaron', 'Adrian', 'Alfie', 'Austin', 'Axel', 'Beau', 'Blake', 'Brady', 'Brandon',
  'Brian', 'Cameron', 'Chase', 'Cole', 'Colin', 'Connor', 'Cooper', 'Curtis', 'Dale',
  'Damian', 'Dean', 'Derek', 'Devin', 'Dominic', 'Eddie', 'Edward', 'Eli', 'Elliott',
  'Eric', 'Evan', 'Everett', 'Felix', 'Fletcher', 'Flynn', 'George', 'Grant',
  'Griffin', 'Harrison', 'Harvey', 'Holden', 'Hudson', 'Hunter', 'Ian', 'Jake',
  'Jasper', 'Jayden', 'Jesse', 'Joel', 'Jonah', 'Julian', 'Justin', 'Kevin', 'Knox',
  'Kyle', 'Lance', 'Landon', 'Leonard', 'Max', 'Miles', 'Marcus', 'Nate', 'Nicholas',
  'Nolan', 'Parker', 'Patrick', 'Paul', 'Peter', 'Preston', 'Quinn', 'Reed', 'Remy',
  'Rex', 'Richard', 'River', 'Robert', 'Rowan', 'Sawyer', 'Scott', 'Seth', 'Simon',
  'Spencer', 'Steven', 'Tanner', 'Travis', 'Tristan', 'Tucker', 'Tyler', 'Vincent',
  'Walter', 'Warren', 'Wesley', 'Xavier', 'Zachary', 'Zane', 'Milo', 'Arthur',
  'Charlie', 'Freddie', 'Harry', 'Archie', 'Toby', 'Kai', 'Atticus', 'Beckett',
  'Caspian', 'Declan', 'Emerson', 'Forrest', 'Gideon', 'Henrik', 'Igor', 'Jude',
  'Kieran', 'Lennox', 'Mattias', 'Niall', 'Oleander', 'Pierce', 'Rafferty', 'Stellan',
  'Thiago', 'Ulric', 'Viggo', 'Wolfgang',
];

// 12 story title templates — 4 are selected per name based on the name's first character
// so every name page shows different titles. {name} is replaced with the actual child's name.
export const NAME_STORY_TITLE_TEMPLATES = [
  '{name} and the Brave Little Dragon',
  'The Night {name} Saved the Stars',
  '{name}\'s Magical Garden Adventure',
  '{name} and the Secret Door to Anywhere',
  'Captain {name} and the Treasure of Kindness',
  '{name} Makes a Friend in the Enchanted Forest',
  'The Day {name} Discovered They Were Magic',
  '{name} and the Robot Who Wanted to Dream',
  'The Amazing {name} and the Impossible Mission',
  '{name}\'s Bedtime Adventure on the Moon',
  'When {name} Met a Friendly Giant',
  '{name} and the Wish-Granting Firefly',
];

// ── New SEO categories ────────────────────────────────────────────────────────

export const LESSONS = [
  { slug: 'kindness',     label: 'Kindness',      emoji: '💛', description: 'Stories that teach children the power of being kind to others, animals, and themselves.' },
  { slug: 'courage',      label: 'Courage',       emoji: '🦁', description: 'Inspiring stories that help children find their inner bravery and face their fears.' },
  { slug: 'sharing',      label: 'Sharing',       emoji: '🤲', description: 'Warm stories that show children the joy of sharing and caring for others.' },
  { slug: 'honesty',      label: 'Honesty',       emoji: '🌟', description: 'Stories that teach children why telling the truth always leads to the best outcome.' },
  { slug: 'friendship',   label: 'Friendship',    emoji: '🤝', description: 'Heartwarming tales about making friends, keeping them, and being a good friend.' },
  { slug: 'perseverance', label: 'Perseverance',  emoji: '🏆', description: "Stories that show children that trying hard and never giving up always pays off." },
  { slug: 'empathy',      label: 'Empathy',       emoji: '❤️', description: 'Stories that help children understand and care about how others feel.' },
  { slug: 'gratitude',    label: 'Gratitude',     emoji: '🙏', description: 'Gentle stories that help children appreciate the good things in their life.' },
  { slug: 'respect',      label: 'Respect',       emoji: '🌈', description: 'Stories about treating others with respect, kindness, and understanding.' },
  { slug: 'confidence',   label: 'Confidence',    emoji: '⭐', description: "Stories that build your child's self-belief and help them believe in themselves." },
];

export const STORY_LENGTHS = [
  { slug: '2-minutes',  label: '2 Minute',   emoji: '⚡', minutes: 2,  description: 'Super quick 2-minute bedtime stories — perfect for very sleepy little ones who just need a tiny tale to drift off.' },
  { slug: '3-minutes',  label: '3 Minute',   emoji: '🌙', minutes: 3,  description: 'Gentle 3-minute bedtime stories — just enough story to settle your child without keeping them awake.' },
  { slug: '5-minutes',  label: '5 Minute',   emoji: '⏱️', minutes: 5,  description: 'Quick, soothing 5-minute bedtime stories perfect for tired little ones who need a fast wind-down.' },
  { slug: 'short',      label: 'Short',      emoji: '📖', minutes: 8,  description: 'Short bedtime stories — just long enough to capture your child\'s imagination without keeping them up.' },
  { slug: '10-minutes', label: '10 Minute',  emoji: '📗', minutes: 10, description: 'Satisfying 10-minute bedtime stories with a proper beginning, middle, and end — perfect for school-age children.' },
  { slug: 'long',       label: 'Long',       emoji: '📚', minutes: 15, description: 'Longer, richer stories for children who love to be immersed in a big adventure before bed.' },
  { slug: '15-minutes', label: '15 Minute',  emoji: '🌟', minutes: 15, description: 'Full 15-minute bedtime stories — a proper chapter-length adventure for children who never want the story to end.' },
];

export const GENDERS = [
  {
    slug: 'for-girls', label: 'Girls', emoji: '👧',
    title: 'Bedtime Stories for Girls',
    description: 'Personalised bedtime stories for girls — featuring brave heroines, magical adventures, and empowering lessons. Every story stars your daughter by name.',
    themes: ['Princesses', 'Unicorns', 'Mermaids', 'Fairies', 'Magic', 'Animals'],
  },
  {
    slug: 'for-boys', label: 'Boys', emoji: '👦',
    title: 'Bedtime Stories for Boys',
    description: 'Personalised bedtime stories for boys — packed with heroic adventures, exciting quests, and fun characters. Every story stars your son by name.',
    themes: ['Dinosaurs', 'Superheroes', 'Space', 'Pirates', 'Robots', 'Dragons'],
  },
];

export const RELATIONSHIPS = [
  { slug: 'from-grandma', label: 'From Grandma', emoji: '👵', description: 'Let grandma tell the bedtime story every night — even from miles away. Clone her voice and your grandchild hears her warmth whenever they need it.' },
  { slug: 'from-grandpa', label: 'From Grandpa', emoji: '👴', description: "Grandpa's voice telling a personalised bedtime story is something a child never forgets. Make it possible every night with voice cloning." },
  { slug: 'from-dad',     label: 'From Dad',     emoji: '👨', description: "Even when dad is travelling for work, his voice can still tell the bedtime story. Clone your voice once and your child hears you every night." },
  { slug: 'from-mum',     label: 'From Mum',     emoji: '👩', description: "Mum's voice is the most comforting sound in the world at bedtime. Clone your voice and be there for bedtime — even when you can't be." },
];

export const COUNTRIES = [
  { slug: 'uk',        label: 'United Kingdom', emoji: '🇬🇧', currency: 'GBP', description: 'Personalised bedtime stories loved by families across the UK. Generate magical stories in British English with your child as the hero.' },
  { slug: 'india',     label: 'India',          emoji: '🇮🇳', currency: 'INR', description: 'Personalised bedtime stories for Indian families — available in Hindi, Gujarati, and English. Your child as the hero of every story.' },
  { slug: 'australia', label: 'Australia',      emoji: '🇦🇺', currency: 'AUD', description: 'Personalised bedtime stories for Aussie families. Magical adventures starring your child — generated in seconds.' },
  { slug: 'canada',    label: 'Canada',         emoji: '🇨🇦', currency: 'CAD', description: 'Personalised bedtime stories for Canadian families. Stories in English and French — starring your child by name.' },
  { slug: 'usa',       label: 'United States',  emoji: '🇺🇸', currency: 'USD', description: 'Personalised bedtime stories loved by families across the USA. Your child as the hero — ready in 15 seconds.' },
  { slug: 'uae',       label: 'UAE',            emoji: '🇦🇪', currency: 'AED', description: 'Personalised bedtime stories for families in the UAE — available in Arabic and English. Every story stars your child.' },
];

export const HOLIDAYS = [
  { slug: 'christmas',  label: 'Christmas',  emoji: '🎄', description: 'Magical Christmas bedtime stories starring your child — with Santa, elves, and festive adventures on Christmas Eve.' },
  { slug: 'eid',        label: 'Eid',        emoji: '🌙', description: 'Beautiful Eid bedtime stories celebrating the joy of the festival — personalised with your child as the hero.' },
  { slug: 'diwali',     label: 'Diwali',     emoji: '🪔', description: 'Sparkling Diwali bedtime stories full of light, colour, and celebration — starring your child by name.' },
  { slug: 'halloween',  label: 'Halloween',  emoji: '🎃', description: 'Fun, not-too-scary Halloween bedtime stories with friendly ghosts and magical pumpkins — starring your child.' },
  { slug: 'easter',     label: 'Easter',     emoji: '🐣', description: 'Joyful Easter bedtime stories with the Easter Bunny and springtime magic — personalised for your child.' },
  { slug: 'hanukkah',   label: 'Hanukkah',   emoji: '🕎', description: 'Warm Hanukkah bedtime stories celebrating light, miracles, and family — starring your child as the hero.' },
];

export const SIBLINGS = [
  { slug: 'for-twins',        label: 'Twins',            emoji: '👯', description: 'Unique bedtime stories starring both twins — two heroes, one magical adventure. Perfect for keeping bedtime fair and special.' },
  { slug: 'for-siblings',     label: 'Siblings',         emoji: '👫', description: 'Bedtime stories featuring all your children together — each one a hero in the same adventure. Every child feels equally special.' },
  { slug: 'for-two-children', label: 'Two Children',     emoji: '👦👧', description: 'One story, two heroes — both children star by name in a shared adventure. A perfect way to end the day together.' },
];

export const GIFTS = [
  { slug: 'gift-for-child',       label: 'Gift for a Child',      emoji: '🎁', description: 'The most unique gift for any child — a personalised bedtime story subscription starring them as the hero. Beats any toy.' },
  { slug: 'gift-for-grandchild',  label: 'Gift for a Grandchild', emoji: '👴👵', description: "Give your grandchild the gift of stories where they're the hero. A Dreamy Bedtime subscription is the gift they'll use every night." },
  { slug: 'birthday-gift-kids',   label: 'Birthday Gift for Kids', emoji: '🎂', description: "Looking for a unique birthday gift for a child? A personalised story subscription is something they'll love every single night." },
];

export const COMPARISONS = [
  { slug: 'personalised',      label: 'Personalised Bedtime Stories', emoji: '✨', description: 'Fully personalised bedtime stories starring your child by name — not generic stories from a book. Created in seconds, loved forever.' },
  { slug: 'with-child-name',   label: 'Stories with Your Child\'s Name', emoji: '📝', description: "Bedtime stories that include your child's name throughout — as the hero of every adventure. Watch their eyes light up." },
  { slug: 'custom',            label: 'Custom Bedtime Stories',      emoji: '🎨', description: 'Custom bedtime stories built around your child — their name, interests, favourite characters, and the lessons you want them to learn.' },
  { slug: 'unique',            label: 'Unique Bedtime Stories',      emoji: '🌟', description: 'Every story is 100% unique — never repeated, never generic. A one-of-a-kind bedtime adventure for your one-of-a-kind child.' },
];

export const BILINGUAL = [
  { slug: 'bilingual',           label: 'Bilingual',              emoji: '🌍', lang1: null,  lang2: null,  description: 'Perfect for bilingual families — create bedtime stories in any language so your child grows up loving both their languages.' },
  { slug: 'english-and-hindi',   label: 'English & Hindi',        emoji: '🇬🇧🇮🇳', lang1: 'English', lang2: 'Hindi',      description: 'For families who speak both English and Hindi — create bedtime stories in either language starring your child.' },
  { slug: 'english-and-spanish', label: 'English & Spanish',      emoji: '🇬🇧🇪🇸', lang1: 'English', lang2: 'Spanish',    description: 'For bilingual English-Spanish families — create personalised bedtime stories in whichever language feels right tonight.' },
  { slug: 'english-and-french',  label: 'English & French',       emoji: '🇬🇧🇫🇷', lang1: 'English', lang2: 'French',     description: 'For English-French families — switch between languages night by night and help your child love both.' },
  { slug: 'english-and-arabic',  label: 'English & Arabic',       emoji: '🇬🇧🇸🇦', lang1: 'English', lang2: 'Arabic',     description: 'Create bedtime stories in English or Arabic — perfect for Arab families raising bilingual children.' },
  { slug: 'english-and-gujarati',label: 'English & Gujarati',     emoji: '🇬🇧🇮🇳', lang1: 'English', lang2: 'Gujarati',   description: 'For Gujarati families in the UK, USA, and Canada — create bedtime stories in Gujarati or English starring your child.' },
];

// ── Animals as Hero ───────────────────────────────────────────────────────────

export const ANIMALS = [
  {
    slug: 'bear', label: 'Bear', emoji: '🐻',
    description: 'Cosy, adventurous bedtime stories starring a lovable bear — perfect for snuggling in.',
    whyKidsLove: "Bear stories combine the warmth of something cuddly with the thrill of wild adventure. From honey-hunting in the forest to befriending unlikely companions, bears capture children's imaginations because they are both powerful and gentle — just like the best bedtime friends. Every child secretly wants a bear as their best friend.",
    storyTitles: [
      'The Little Bear Who Was Afraid of Bees',
      'Bruno Bear and the Midnight Honey Hunt',
      'The Bear Who Loved to Read Stories',
      'When Bear Met a Child Who Needed a Friend',
    ],
    facts: [
      "Bears are excellent swimmers and some can swim for miles without stopping",
      "A bear's sense of smell is seven times stronger than a dog's — the best nose of any land animal",
      "Bears are incredibly intelligent and have been observed using tools and solving complex puzzles",
    ],
  },
  {
    slug: 'bunny', label: 'Bunny', emoji: '🐰',
    description: 'Sweet, gentle bedtime stories starring an adorable bunny full of curiosity and heart.',
    whyKidsLove: "Bunny stories are the softest, most comforting bedtime adventures a child can have. Bunnies are fast, curious, and full of surprises — but they always find their way home before dark. These stories help children feel safe, loved, and ready to drift off into their own peaceful dreams.",
    storyTitles: [
      'The Bunny Who Hopped Too Far and Found Something Wonderful',
      'Cottontail and the Garden Full of Secrets',
      'The Bunny Who Was Afraid of the Big Wide World',
      "Little Bunny's Very First Snowfall",
    ],
    facts: [
      "Rabbits can run at speeds of up to 45 miles per hour when they need to",
      "Bunnies have nearly 360-degree vision so they can spot danger from almost any direction",
      "A happy bunny will leap and twist in the air — a move called a 'binky'",
    ],
  },
  {
    slug: 'lion', label: 'Lion', emoji: '🦁',
    description: 'Brave, majestic bedtime stories starring the king of the jungle with a heart of gold.',
    whyKidsLove: "Lion stories speak to something deep inside every child — the part that wants to be brave, strong, and kind all at once. The best lion heroes discover that true courage isn't about roaring the loudest; it's about protecting the ones you love and standing up for what is right.",
    storyTitles: [
      'The Lion Who Was Afraid to Roar',
      'Leo the Lion and the Tiny Mouse Who Saved Him',
      'The Cub Who Would Be King — But Chose to Be Kind',
      'When the Lion Discovered the Power of a Gentle Heart',
    ],
    facts: [
      "Lions are the only cats that live in social groups called prides — family is everything to them",
      "A lion's roar can be heard from five miles away — one of the loudest sounds in the animal kingdom",
      "Female lions do most of the hunting and are faster and more agile than the males",
    ],
  },
  {
    slug: 'elephant', label: 'Elephant', emoji: '🐘',
    description: "Wise, gentle bedtime stories starring the world's most memory-gifted creature.",
    whyKidsLove: "Elephant stories are among the most emotionally rich adventures in the animal kingdom. Elephants never forget a friend, always protect their family, and feel emotions just like we do. These stories help children understand empathy, loyalty, and the quiet strength of being gentle in a big world.",
    storyTitles: [
      'The Elephant Who Never Forgot a Kindness',
      'Ellie and the River That Ran Dry',
      'The Smallest Elephant in the Biggest Herd',
      'When Grandma Elephant Told the Story of the Great Journey',
    ],
    facts: [
      "Elephants are one of the few animals that recognise themselves in a mirror — a sign of self-awareness",
      "Elephants grieve for loved ones and have been observed returning to the bones of family members years later",
      "A baby elephant can stand within minutes of being born and is cared for by the whole herd",
    ],
  },
  {
    slug: 'cat', label: 'Cat', emoji: '🐱',
    description: 'Curious, clever bedtime stories starring an independent cat on midnight adventures.',
    whyKidsLove: "Cat stories are mysterious, clever, and full of quiet magic. Cats explore the world on their own terms — sneaking through moonlit gardens and discovering secrets no one else can see. For children who love a touch of mystery with their bedtime, a cat hero is absolutely purr-fect.",
    storyTitles: [
      'The Cat Who Could See in the Dark',
      "Midnight and the Moon's Secret Message",
      'The Cat Who Refused to Come Home',
      'Whiskers and the House Full of Wishes',
    ],
    facts: [
      "Cats can rotate their ears independently — giving them extraordinary hearing in two directions at once",
      "A cat's purr vibrates at a frequency shown to promote healing in both cats and humans",
      "Cats spend around 70% of their lives sleeping — making them the ultimate bedtime companions",
    ],
  },
  {
    slug: 'dog', label: 'Dog', emoji: '🐶',
    description: 'Loyal, joyful bedtime stories starring the most faithful friend a child could have.',
    whyKidsLove: "Dog stories are about unconditional love, boundless energy, and loyalty that never wavers. A dog hero always shows up, always tries their best, and always comes home wagging. These stories help children understand friendship, trust, and what it means to love someone no matter what.",
    storyTitles: [
      'The Dog Who Waited at the Gate Every Single Day',
      'Biscuit and the Boy Who Couldn\'t Sleep',
      'The Puppy Who Was Different From All the Others',
      'When Max the Dog Saved the Whole Neighbourhood',
    ],
    facts: [
      "Dogs can understand up to 250 words and gestures — about the same as a 2-year-old child",
      "Dogs have a unique nose print — just like a human fingerprint, no two are the same",
      "Dogs have been humanity's companions for over 15,000 years — the oldest friendship in history",
    ],
  },
  {
    slug: 'fox', label: 'Fox', emoji: '🦊',
    description: 'Clever, enchanting bedtime stories starring the most cunning and charming creature in the woods.',
    whyKidsLove: "Fox stories are filled with wit, warmth, and a little bit of mischief. Foxes are tricksters with hearts of gold — clever enough to outsmart anyone, but kind enough to always help a friend in need. Children adore fox heroes because they prove that being smart and being good go perfectly together.",
    storyTitles: [
      'The Fox Who Outsmarted Everyone — Except Herself',
      'Ruby Fox and the Frozen Winter Forest',
      'The Fox Who Returned What He Borrowed',
      'When Fox and Rabbit Finally Became Friends',
    ],
    facts: [
      "Foxes use the Earth's magnetic field to help them hunt — they can sense direction like a compass",
      "A fox's home is called a den, and they are devoted parents who care for their cubs together",
      "Foxes make over 40 different sounds to communicate — including a scream that sounds remarkably human",
    ],
  },
  {
    slug: 'owl', label: 'Owl', emoji: '🦉',
    description: 'Wise, mysterious bedtime stories starring the nocturnal guardian of the night forest.',
    whyKidsLove: "Owl stories are the perfect companion for bedtime — these night creatures are active exactly when children are heading to sleep. Owls are associated with wisdom, mystery, and the magic of the moonlit world. Stories featuring owls help children feel at peace with the night and all its wonderful secrets.",
    storyTitles: [
      'The Owl Who Kept Watch Over the Sleeping World',
      'Professor Hoot and the Library of Lost Dreams',
      'The Baby Owl Who Was Afraid of the Dark',
      'When Owl Taught the Moon a New Song',
    ],
    facts: [
      "Owls can rotate their heads up to 270 degrees — nearly all the way around",
      "A group of owls is called a parliament — fitting for such wise birds",
      "Owls fly almost silently thanks to the unique structure of their feathers",
    ],
  },
  {
    slug: 'penguin', label: 'Penguin', emoji: '🐧',
    description: 'Adventurous, heartwarming bedtime stories starring the most determined birds on Earth.',
    whyKidsLove: "Penguin stories are wonderfully funny and deeply moving at the same time. Penguins are flightless birds who swim like fish, waddle like toddlers, and love their families fiercely. They prove that being different isn't a disadvantage — it's exactly what makes you extraordinary.",
    storyTitles: [
      'The Penguin Who Wanted to Fly',
      "Percy Penguin's Very Long Journey Home",
      'The Penguin Who Made Friends With the Sun',
      'When the Baby Penguin Got Lost in the Blizzard',
    ],
    facts: [
      "Emperor penguins can dive over 1,800 feet deep and hold their breath for more than 20 minutes",
      "Male emperor penguins balance their eggs on their feet for months in the harshest conditions on Earth",
      "Penguins recognise each other by the unique sound of their calls — even in a crowd of thousands",
    ],
  },
  {
    slug: 'turtle', label: 'Turtle', emoji: '🐢',
    description: 'Gentle, patient bedtime stories starring the wise old traveller of land and sea.',
    whyKidsLove: "Turtle stories teach children that slow and steady truly does win the race. Turtles have been on Earth for millions of years — patient, wise, and quietly extraordinary. These stories show children that you don't need to be the fastest or the loudest to be a hero. Patience and kindness always carry you home.",
    storyTitles: [
      'The Turtle Who Took the Long Way Home',
      'Old Shell and the Secret of the Deep Blue Sea',
      'The Turtle Who Crossed the Whole Ocean',
      'Why Turtle Always Wins in the End',
    ],
    facts: [
      "Sea turtles have existed for more than 100 million years — they outlived the dinosaurs",
      "Leatherback sea turtles can travel up to 10,000 miles in a single year",
      "Turtles don't have teeth but their beak is strong enough to crush shells",
    ],
  },
  {
    slug: 'horse', label: 'Horse', emoji: '🐴',
    description: 'Spirited, beautiful bedtime stories starring the most majestic animal on the open plains.',
    whyKidsLove: "Horse stories are about freedom, courage, and the bond between a child and the most magnificent creature in the world. Children are drawn to horses because they represent the wild spirit inside all of us — the part that wants to run fast, feel the wind, and go somewhere wonderful.",
    storyTitles: [
      'The Wild Horse Who Finally Trusted a Child',
      'Starlight and the Girl Who Wouldn\'t Give Up',
      'The Horse Who Ran to the Edge of the World',
      'The Night the Stable Horse Became a Hero',
    ],
    facts: [
      "Horses can sleep both standing up and lying down — and they need both kinds of sleep",
      "Horses have the largest eyes of any land mammal and can see almost 360 degrees",
      "A horse's teeth never stop growing throughout their entire life",
    ],
  },
  {
    slug: 'wolf', label: 'Wolf', emoji: '🐺',
    description: 'Wild, loyal bedtime stories starring the misunderstood hero of the moonlit forest.',
    whyKidsLove: "Wolf stories challenge children to look beyond first impressions and see the beauty in what's different. Wolves are fiercely loyal to their pack, exceptional parents, and far gentler than their reputation suggests. These stories teach children that the scariest-looking thing can often have the kindest heart.",
    storyTitles: [
      'The Wolf Who Only Wanted to Howl at the Moon',
      'Luna Wolf and the Pack She Found',
      'The Wolf Who Was Different from All the Others',
      'When the Village Finally Understood the Wolf',
    ],
    facts: [
      "Wolves mate for life — a wolf without their partner will mourn for years",
      "A wolf pack is really a family — led by a mum and dad who care for the whole group",
      "Wolves howl to communicate with family members miles away and to celebrate being together",
    ],
  },
  {
    slug: 'panda', label: 'Panda', emoji: '🐼',
    description: "Adorable, peaceful bedtime stories starring the world's most beloved gentle giant.",
    whyKidsLove: "Panda stories are pure joy — these round, bamboo-munching, tumbling giants are nature's gift to children everywhere. But beneath the cuddly exterior is a surprisingly determined animal who works incredibly hard and loves intensely. Panda stories show that the softest hearts are often the bravest.",
    storyTitles: [
      'Bao the Panda and the Very Last Bamboo Shoot',
      'The Panda Who Rolled Down the Wrong Mountain',
      'Little Panda and the Friend Nobody Else Could See',
      'When the Whole Forest Came to Help One Small Panda',
    ],
    facts: [
      "Giant pandas spend 10 to 16 hours every day eating bamboo — it's basically their full-time job",
      "Baby pandas are born pink, blind, and tiny — about the size of a stick of butter",
      "Pandas have a special extra 'thumb' — actually an enlarged wrist bone — to help them grip bamboo",
    ],
  },
  {
    slug: 'monkey', label: 'Monkey', emoji: '🐒',
    description: 'Playful, clever bedtime stories starring the most mischievous acrobat in the jungle.',
    whyKidsLove: "Monkey stories are an adventure in curiosity, creativity, and just a little bit of chaos. Monkeys are inventive, funny, and social — they love playing, learning, and looking out for their friends. For children who love to laugh, swing from ideas, and never stop asking questions, a monkey hero is the perfect guide.",
    storyTitles: [
      'The Monkey Who Touched the Top of the Tree',
      'Mango and the Fruit That Wasn\'t There',
      'The Monkey Who Learned to Be Still',
      'When the Monkeys Saved the Jungle by Being Silly',
    ],
    facts: [
      "Some monkeys can use tools — they've been observed cracking nuts with rocks just like early humans",
      "Howler monkeys are the loudest land animal — their calls carry for up to three miles",
      "Monkeys groom each other not just for cleanliness but as a way of showing love and building friendship",
    ],
  },
  {
    slug: 'giraffe', label: 'Giraffe', emoji: '🦒',
    description: 'Tall, graceful bedtime stories starring the most uniquely wonderful animal on the savannah.',
    whyKidsLove: "Giraffe stories are for children who feel a little different — a little taller, a little quieter, a little more themselves than everyone around them. Giraffes see the world from a perspective nobody else can reach, and they carry themselves with quiet, gentle confidence. The perfect hero for a child finding their own way.",
    storyTitles: [
      'The Giraffe Who Was Embarrassed by Her Neck',
      'How Gerald the Giraffe Saw Over Every Problem',
      'The Giraffe Who Made Friends With the Clouds',
      'When Being Different Turned Out to Be Exactly Right',
    ],
    facts: [
      "Giraffes sleep for only around 30 minutes a day — usually in short naps of just a few minutes",
      "A giraffe's tongue is around 45cm long and dark purple to protect it from sunburn",
      "Baby giraffes are born already standing at 6 feet tall — and can run within hours of birth",
    ],
  },
  {
    slug: 'dolphin', label: 'Dolphin', emoji: '🐬',
    description: 'Joyful, brilliant bedtime stories starring the most playful genius of the ocean.',
    whyKidsLove: "Dolphin stories are pure happiness — these ocean acrobats leap, spin, and race through the waves with an infectious joy that children absolutely love. But dolphins are also deeply intelligent and fiercely caring — they protect each other, communicate in complex ways, and play just for the fun of it.",
    storyTitles: [
      'The Dolphin Who Could Talk to the Stars',
      'Flip and the Boat She Guided Home',
      'The Youngest Dolphin in the Pod',
      'When the Ocean Sang and the Dolphins Danced',
    ],
    facts: [
      "Dolphins have names for each other — they use unique whistles to identify specific individuals",
      "Dolphins sleep with one eye open and one half of their brain awake — always alert for danger",
      "A group of dolphins will support a sick or injured member of their pod — holding them up at the surface to breathe",
    ],
  },
  {
    slug: 'whale', label: 'Whale', emoji: '🐋',
    description: 'Majestic, awe-inspiring bedtime stories starring the gentlest giant in all the ocean.',
    whyKidsLove: "Whale stories fill children with a sense of wonder that is hard to match. These ancient, enormous, and deeply gentle creatures have roamed the oceans for millions of years. Their songs travel thousands of miles through the deep. For children who love to think big, dream deep, and feel the vastness of the world, a whale hero is magic.",
    storyTitles: [
      'The Whale Whose Song the Whole Ocean Heard',
      'The Baby Blue Whale and the Very Deep Sea',
      'When the Whale Carried the Lost Child Home',
      'The Song That Crossed the Ocean and Found Its Way Back',
    ],
    facts: [
      "Blue whales are the largest animals ever known to have lived on Earth — their hearts are the size of a small car",
      "Humpback whale songs can last for hours and are heard by whales thousands of miles away",
      "Whales breathe air just like we do — every dive is followed by a surfacing breath at the top of the world",
    ],
  },
  {
    slug: 'butterfly', label: 'Butterfly', emoji: '🦋',
    description: 'Beautiful, transformative bedtime stories about the wonder of becoming who you are meant to be.',
    whyKidsLove: "Butterfly stories are the ultimate tales of transformation — starting as something small and quiet, going through a period of change, and emerging as something breathtakingly beautiful. Every child going through their own changes can see themselves in a butterfly hero and feel excited rather than afraid.",
    storyTitles: [
      'The Caterpillar Who Was Afraid of the Cocoon',
      'Flutter and the Garden Full of Colours',
      'The Butterfly Who Flew Around the Whole World',
      'When the Ugly Caterpillar Became the Most Beautiful Thing',
    ],
    facts: [
      "A butterfly's wings are covered in thousands of tiny scales that create their patterns and colours",
      "Monarch butterflies migrate up to 3,000 miles every year — one of nature's most extraordinary journeys",
      "Butterflies taste with their feet — they land on food before they can even smell it",
    ],
  },
  {
    slug: 'hedgehog', label: 'Hedgehog', emoji: '🦔',
    description: 'Prickly on the outside, perfectly sweet on the inside — bedtime stories for gentle souls.',
    whyKidsLove: "Hedgehog stories are for children who understand that sometimes the prickliest exterior hides the softest heart. Hedgehogs are small, determined, nocturnal adventurers who find their way through the darkest nights with quiet confidence. Perfect for the child who feels misunderstood but knows their own worth.",
    storyTitles: [
      'The Hedgehog Who Curled Up Too Tight',
      'Prickle and the Friend Who Wasn\'t Scared',
      'The Hedgehog Who Came Out of Her Shell',
      'When the Prickliest Creature in the Forest Saved the Day',
    ],
    facts: [
      "Hedgehogs are immune to many venomous snakes — their spines provide remarkable protection",
      "A hedgehog has between 5,000 and 7,000 spines — each one hollow and made of keratin like human fingernails",
      "Hedgehogs are nocturnal and can travel several miles in a single night on their tiny legs",
    ],
  },
];

// ── Story Settings ────────────────────────────────────────────────────────────

export const SETTINGS = [
  {
    slug: 'enchanted-forest', label: 'Enchanted Forest', emoji: '🌲',
    description: 'Magical bedtime stories set deep in an enchanted forest where trees whisper and fireflies light the way.',
    whyItsMagical: "The enchanted forest is the oldest and most powerful setting in all of storytelling. Every rustling leaf hides a secret, every glowing mushroom marks a path to somewhere wonderful, and every twist in the trail leads to a new friend or a new discovery. Children instinctively understand that something magical lives in the deep, dark wood.",
    storyTitles: [
      'The Child Who Found the Heart of the Enchanted Forest',
      'Where the Fireflies Never Go Out',
      'The Tree That Had Been Standing for a Thousand Years',
      'The Secret Path That Only Appeared at Night',
    ],
    facts: [
      "Forests cover about 31% of the Earth's land surface and are home to over 80% of land-dwelling species",
      "Some forests contain trees that communicate with each other through underground fungal networks called the 'wood wide web'",
      "The Amazon rainforest is so large that it creates its own weather — including its own clouds and rainfall",
    ],
  },
  {
    slug: 'magic-castle', label: 'Magic Castle', emoji: '🏰',
    description: 'Grand bedtime stories set inside a magical castle full of secrets, towers, and enchanted rooms.',
    whyItsMagical: "A magic castle is every child's dream — endless corridors to explore, towers that touch the clouds, and rooms that reveal themselves only to those who are brave enough to look. Every door could lead to a library of talking books, a kitchen that cooks on its own, or a ballroom where the furniture dances.",
    storyTitles: [
      'The Castle With One Hundred Locked Doors',
      'The Smallest Room in the Biggest Castle',
      'The Night the Castle Came Alive',
      'Where the Ghost in the Tower Finally Told Its Secret',
    ],
    facts: [
      "The oldest inhabited castle in the world is Windsor Castle in England — lived in continuously for over 900 years",
      "Many medieval castles had secret passages built into their walls for escape in times of siege",
      "Scotland has more castles per square mile than almost any other country in the world",
    ],
  },
  {
    slug: 'underwater-kingdom', label: 'Underwater Kingdom', emoji: '🌊',
    description: 'Breathtaking bedtime stories set deep beneath the waves in a shimmering underwater world.',
    whyItsMagical: "The underwater world is the most mysterious and unexplored place on Earth — more of our ocean is uncharted than the surface of Mars. For a child's imagination, the deep sea is a limitless canvas: bioluminescent creatures that glow in the dark, ancient shipwrecks full of treasure, and kingdoms built entirely of coral.",
    storyTitles: [
      'The Kingdom Below the Deepest Wave',
      'Coral City and the Child Who Breathed Underwater',
      'The Lighthouse Keeper Who Could Talk to Fish',
      'When the Tide Went Out and Left a Whole World Behind',
    ],
    facts: [
      "More than 80% of Earth's oceans have never been explored or mapped by humans",
      "There are mountains, volcanoes, and rivers flowing at the bottom of the ocean",
      "Scientists discover approximately 2,000 new ocean species every single year",
    ],
  },
  {
    slug: 'space-station', label: 'Space Station', emoji: '🚀',
    description: 'Thrilling bedtime stories set aboard a space station orbiting high above the stars.',
    whyItsMagical: "A space station is the most extraordinary place any human has ever called home — floating in silence above the whole world, watching sunrises happen sixteen times a day, and sleeping strapped to the wall while Earth turns slowly below. For children who look up at the night sky and wonder, a space station is the ultimate adventure.",
    storyTitles: [
      'The Youngest Astronaut on the Space Station',
      'Night Watch: Guarding the Stars From Above',
      'The Day the Space Station Got a Surprise Visitor',
      'Mission Control: Something Amazing is Heading Our Way',
    ],
    facts: [
      "The International Space Station travels at 17,500 miles per hour — circling Earth every 90 minutes",
      "Astronauts on the ISS see 16 sunrises and 16 sunsets every single day",
      "In space, tears don't fall — they form into floating spheres of water around astronauts' eyes",
    ],
  },
  {
    slug: 'fairy-village', label: 'Fairy Village', emoji: '🧚',
    description: 'Enchanting bedtime stories set in a tiny, magical fairy village hidden inside an old oak tree.',
    whyItsMagical: "The fairy village exists just out of sight — in the hollow of an oak tree, beneath a garden stone, or inside the petals of a flower. It is a world of miniature wonder where every acorn cap is a bowl, every dewdrop is a swimming pool, and every night is lit by the warm glow of firefly lanterns. A world that rewards those who look closely.",
    storyTitles: [
      'The Human Child Who Found the Fairy Village',
      'The Fairy Who Wanted to Live in the Big World',
      'The Night the Fairy Lights Went Out',
      'Mayor Petal and the Great Acorn Crisis',
    ],
    facts: [
      "Fairy folklore exists in virtually every culture on Earth — from Celtic fairies to Japanese tengu to West African spirits",
      "The oldest recorded fairy tale — 'The Smith and the Devil' — dates back at least 6,000 years",
      "In Ireland, certain hills are still considered fairy homes — locals will not build on or disturb them",
    ],
  },
  {
    slug: 'treehouse', label: 'Treehouse', emoji: '🌳',
    description: 'Adventurous bedtime stories set high up in a magical treehouse that overlooks the whole world.',
    whyItsMagical: "A treehouse is the ultimate childhood dream — a private world above the ground where the rules are different, the view is extraordinary, and anything is possible. From a treehouse you can see the whole neighbourhood, watch the stars come out, and feel like the ruler of your own small kingdom at the top of the world.",
    storyTitles: [
      'The Treehouse That Had One Hundred Floors',
      'The Night the Treehouse Floated Away',
      'The Secret Club at the Top of the Garden',
      'Building the Best Treehouse in the Whole World',
    ],
    facts: [
      "The world's largest treehouse — in Crossville, Tennessee — has over 10 floors and took 11 years to build",
      "Some trees in the world are so large that humans have built homes, restaurants, and hotels inside them",
      "Treehouses have been used by cultures around the world for thousands of years — some for defence, some for ceremony",
    ],
  },
  {
    slug: 'secret-garden', label: 'Secret Garden', emoji: '🌸',
    description: 'Beautiful, healing bedtime stories set inside a hidden garden that blooms for those who care for it.',
    whyKidsLove: "A secret garden is a place of extraordinary quiet magic — discovered through a hidden door, a forgotten key, or a path overgrown with moss. Inside, nature takes care of those who take care of it. Secret garden stories teach children about patience, growth, and the extraordinary things that happen when you nurture something with love.",
    storyTitles: [
      'The Door in the Wall That Nobody Had Opened',
      'The Garden That Bloomed Only for One Child',
      'The Seeds That Grew When Someone Finally Cared',
      'The Secret Garden and the Friend Who Found It First',
    ],
    facts: [
      "Some seeds can remain dormant for decades before finding the right conditions to bloom",
      "Gardens have been used as places of healing and peace for thousands of years across many cultures",
      "The world's oldest living garden — the Humble Administrator's Garden in China — is over 500 years old",
    ],
  },
  {
    slug: 'desert-oasis', label: 'Desert Oasis', emoji: '🏜️',
    description: 'Mystical bedtime stories set in a shimmering desert oasis where magic and miracles meet.',
    whyItsMagical: "A desert oasis is where the impossible becomes real — in the middle of the harshest, most barren place on Earth, a small miracle of water and life appears. Oasis stories are about hope, endurance, and the discovery that even the driest places can hold the most surprising treasures.",
    storyTitles: [
      'The Child Who Found Water in the Desert',
      'The Oasis That Only Appeared at Midnight',
      "The Merchant's Daughter and the Palm Tree That Spoke",
      'Where the Caravan Stopped and Found Something Magical',
    ],
    facts: [
      "The Sahara desert is the largest hot desert on Earth — almost as big as the whole of the USA",
      "Despite their reputation, deserts are home to thousands of species of animals, plants, and insects",
      "Ancient trade routes through the Sahara connected civilizations for thousands of years",
    ],
  },
  {
    slug: 'mountain-kingdom', label: 'Mountain Kingdom', emoji: '🏔️',
    description: 'Epic bedtime stories set high in a misty mountain kingdom above the clouds.',
    whyItsMagical: "Mountain kingdoms exist at the place where earth meets sky — above the clouds, where eagles nest and snow never fully melts. These are places of ancient power and extraordinary beauty, where every summit reveals a new world. Stories set in mountain kingdoms inspire children to climb higher, reach further, and never stop before the summit.",
    storyTitles: [
      'The Kingdom Hidden Above the Clouds',
      'The Child Who Climbed to the Very Top',
      'The Mountain That Moved When Nobody Was Looking',
      'The King of the Peaks and the Child Who Wasn\'t Afraid',
    ],
    facts: [
      "Mount Everest grows by about 4mm every year as the tectonic plates beneath it continue to push upward",
      "More than 100 distinct mountain cultures have lived in high-altitude communities for thousands of years",
      "The Himalayas are young mountains — only about 50 million years old, still growing",
    ],
  },
  {
    slug: 'pirate-ship', label: 'Pirate Ship', emoji: '🏴‍☠️',
    description: 'Swashbuckling bedtime stories set aboard a magnificent pirate ship sailing uncharted seas.',
    whyItsMagical: "A pirate ship is the ultimate symbol of freedom — cutting through the waves with no fixed destination, guided by stars and wind and the spirit of adventure. Aboard a pirate ship, every child is a crew member with a role to play, a horizon to sail toward, and a treasure waiting somewhere at the edge of the map.",
    storyTitles: [
      'The Youngest Crew Member on the Sea Hawk',
      'The Pirate Ship That Could Think for Itself',
      'The Night the Map Showed a Place Nobody Had Seen',
      'Captain Courage and the Storm They Sailed Through Together',
    ],
    facts: [
      "During the golden age of piracy, many pirate ships were democratic — crews voted on decisions together",
      "Sailors navigated by the stars for thousands of years before modern instruments were invented",
      "The largest wooden ship ever built was the Wyoming — a six-masted schooner stretching 450 feet",
    ],
  },
  {
    slug: 'ice-palace', label: 'Ice Palace', emoji: '❄️',
    description: 'Dazzling bedtime stories set inside a breathtaking palace carved entirely from ancient ice.',
    whyItsMagical: "An ice palace is one of the most visually stunning settings imaginable — every wall catches light differently, corridors shift from blue to white to silver as you move, and the entire structure is alive with a cold, beautiful magic. Stories set here explore themes of isolation, transformation, and the warmth of connection in the coldest places.",
    storyTitles: [
      'The Queen of the Frozen Palace and the Child Who Melted Her Heart',
      'The Palace That Sang When the Wind Blew Through',
      'Finding Warmth in the Coldest Kingdom on Earth',
      'The Ice Prince Who Had Never Felt the Sun',
    ],
    facts: [
      "Real ice hotels are built every winter in Scandinavia from thousands of tons of ice and snow",
      "The Eisriesenwelt cave system in Austria contains the world's largest ice caves — stretching over 42km",
      "Ice can be blue because ancient, compressed glacial ice contains no air bubbles to scatter light",
    ],
  },
  {
    slug: 'cloud-city', label: 'Cloud City', emoji: '☁️',
    description: 'Dreamy bedtime stories set high above the world in a magical city built entirely of clouds.',
    whyItsMagical: "A city built on clouds is the purest expression of a bedtime dream — soft, floating, lit by sunrise colours, and reachable only by those with enough imagination. Cloud cities drift slowly across the sky, changing shape as they go, always heading somewhere new. They are the perfect setting for a story that exists exactly halfway between waking and sleep.",
    storyTitles: [
      'The Child Who Climbed Straight Up Into the Clouds',
      'Cloud City and the Mapmaker Who Lived There',
      'The Day the Cloud City Floated Over Their House',
      'The Boy Who Built a Staircase to the Sky',
    ],
    facts: [
      "Clouds are made of millions of tiny water droplets or ice crystals — yet some clouds weigh over a million pounds",
      "Cumulonimbus clouds — thunderstorm clouds — can reach heights of over 60,000 feet",
      "The highest clouds in Earth's atmosphere — noctilucent clouds — form at the very edge of space",
    ],
  },
  {
    slug: 'candy-land', label: 'Candy Land', emoji: '🍭',
    description: 'Deliciously magical bedtime stories set in a world where everything is made of sweets and wonder.',
    whyItsMagical: "Candy Land is the most delightfully impossible place a child can visit — a world where the rivers flow with chocolate, the flowers are made of sugar, and the mountains are built of gingerbread. These stories are pure, unapologetic imagination at its sweetest, reminding children that some places exist only in dreams — which makes them worth having.",
    storyTitles: [
      'The Child Who Found the Entrance to Candy Land',
      'The Lollipop Forest and What Lives Inside It',
      'The Mayor of Chocolate Mountain',
      'The Night the Candy Land River Ran the Wrong Way',
    ],
    facts: [
      "The original Candy Land board game was invented in 1948 by a teacher in a polio ward to entertain sick children",
      "The world's largest chocolate structure ever built weighed over 10,000 kilograms",
      "Honey never expires — archaeologists have found 3,000-year-old honey in Egyptian tombs that was still edible",
    ],
  },
  {
    slug: 'dragon-cave', label: 'Dragon Cave', emoji: '🐉',
    description: 'Thrilling bedtime stories set deep inside a dragon\'s glittering cave full of gold and secrets.',
    whyItsMagical: "A dragon's cave is the most dramatic setting in all of children's storytelling — a place that smells of woodsmoke and ancient gold, where the walls glow from a fire that has burned for a thousand years. Entering a dragon's cave requires more than bravery. It requires kindness, wisdom, and the understanding that the scariest door often leads to the most extraordinary friendship.",
    storyTitles: [
      'The Child Who Knocked on the Dragon\'s Door',
      'The Dragon Who Collected Books Instead of Gold',
      'Deep in the Cave That Nobody Dared Enter Twice',
      'The Night the Dragon\'s Fire Finally Went Out',
    ],
    facts: [
      "Dragon legends appear independently in Chinese, European, Indian, and African cultures — with no contact between them",
      "The largest cave in the world — Son Doong Cave in Vietnam — is large enough to contain a jungle and its own weather",
      "Many ancient cultures believed that large fossils found underground were the bones of dragons",
    ],
  },
  {
    slug: 'time-machine', label: 'Time Machine', emoji: '⏰',
    description: 'Adventurous bedtime stories aboard a magical time machine travelling to any moment in history.',
    whyItsMagical: "A time machine is the most exciting vehicle ever imagined — one that doesn't go left or right, but forwards and backwards through time itself. With a time machine, a child can witness the building of the pyramids, walk with dinosaurs, or travel to tomorrow to see what amazing things are waiting. These stories spark curiosity about history and the future in equal measure.",
    storyTitles: [
      'The Time Machine in the Garden Shed',
      'Back to the Day the Dinosaurs Were Still Alive',
      'The Child Who Visited Every Era in One Night',
      'The Time Traveller Who Kept Getting the Year Wrong',
    ],
    facts: [
      "Einstein's theory of relativity actually predicts that time travel into the future is possible if you travel fast enough",
      "If you flew at the speed of light for a year and returned, you would be younger than everyone you left behind",
      "Some scientists believe that black holes could theoretically act as natural time machines",
    ],
  },
];

// ── Moods / Tones ─────────────────────────────────────────────────────────────

export const MOODS = [
  {
    slug: 'calming', label: 'Calming', emoji: '🌸',
    description: 'Soft, soothing bedtime stories designed to help your child wind down and drift peacefully off to sleep.',
    whyItHelps: "Calming bedtime stories are one of the most effective tools for helping children transition from the busyness of the day into the stillness of sleep. Gentle narratives with peaceful imagery, slow pacing, and reassuring resolutions signal to a child's nervous system that it is safe to relax. Story by story, night by night, this becomes one of the most powerful bedtime routines you can build.",
    bestFor: ['Children who struggle to wind down', 'Anxious or sensitive children', 'Toddlers and young children', 'Any night when the day has been particularly big or overwhelming'],
    storyTitles: [
      'The Sleepy Little Cloud That Drifted Away',
      'When the Whole World Went Quiet for the Night',
      'The Lullaby That Came Alive',
      'Floating Slowly Down the Gentle River',
    ],
  },
  {
    slug: 'funny', label: 'Funny', emoji: '😄',
    description: 'Hilarious bedtime stories that make children laugh out loud before they drift off smiling.',
    whyItHelps: "Laughter is one of the best ways to end a difficult day — it releases tension, creates joy, and sends children to sleep with a smile on their face. Funny bedtime stories also build a shared sense of humour between parent and child, creating memories that last far longer than the story itself. The sillier the better.",
    bestFor: ['Children who need to end the day on a high note', 'Siblings who love to giggle together', 'Parents who love to hear their child laugh', 'Any night when things have felt a bit too serious'],
    storyTitles: [
      'The Dragon Who Couldn\'t Stop Sneezing',
      'The Day the Whole Town Wore Their Pyjamas Outside',
      'The Wizard Who Kept Spelling Everything Wrong',
      'The Frog Who Made Himself King for Absolutely No Reason',
    ],
  },
  {
    slug: 'exciting', label: 'Exciting', emoji: '⚡',
    description: 'Action-packed bedtime stories with thrilling twists that keep children gripped until the satisfying end.',
    whyItHelps: "Exciting stories engage children at the highest level of attention — they lean in, hold their breath, and completely forget they were trying to avoid bedtime. The key is a satisfying ending that resolves the tension and leaves children feeling safe and triumphant before they close their eyes. Excitement that ends in peace is the perfect bedtime formula.",
    bestFor: ['Older children who find "boring" stories resistible', 'Children who love action films and adventure games', 'Parents who want bedtime to feel like an event', 'Any night when children need something genuinely gripping to look forward to'],
    storyTitles: [
      'The Heist at the End of the World',
      'Three Seconds Until the Rocket Launched',
      'The Race Nobody Was Supposed to Win',
      'The Night Everything Almost Went Wrong — Then Didn\'t',
    ],
  },
  {
    slug: 'heartwarming', label: 'Heartwarming', emoji: '❤️',
    description: 'Tender, emotional bedtime stories that fill children with love and the feeling that everything is going to be alright.',
    whyItHelps: "Heartwarming stories create an emotional safety net for children — they remind little ones that they are loved, that kindness exists in the world, and that things generally work out for those who try their best. These stories are particularly powerful during times of change or uncertainty, when children most need to feel the warmth of connection and belonging.",
    bestFor: ['Children going through a difficult time', 'Children who need reassurance and emotional warmth', 'Family bonding moments', 'Parents who want to create an emotionally rich bedtime tradition'],
    storyTitles: [
      'The Grandparent Who Told the Best Stories in the World',
      'The Friend Who Stayed When Everyone Else Left',
      'The Day Someone Finally Understood',
      'Coming Home: A Story About Love That Never Goes Away',
    ],
  },
  {
    slug: 'spooky', label: 'Spooky', emoji: '👻',
    description: 'Gently spooky bedtime stories — just scary enough to be thrilling, always safe enough to sleep well after.',
    whyItHelps: "Gently spooky stories are enormously appealing to children because they offer the thrill of being scared in a completely controlled, completely safe environment. The monster under the bed always turns out to need a friend. The haunted house always has a kind ghost inside. These stories help children process fears and discover that the scary thing is almost never as frightening as it seemed.",
    bestFor: ['Children who love a little frisson of excitement', 'Halloween season and autumn evenings', 'Children who are working through fears of the dark or scary things', 'Older children who find very gentle stories too quiet'],
    storyTitles: [
      'The Ghost Who Knocked Three Times and Then Said Sorry',
      'The Haunted House That Was Only Haunted by Kindness',
      'The Thing Under the Bed Just Wanted a Blanket',
      'Not-So-Scary: A Spooky Story for Brave Little Ones',
    ],
  },
  {
    slug: 'adventurous', label: 'Adventurous', emoji: '🗺️',
    description: 'Bold, journey-filled bedtime stories where brave children explore unknown worlds and discover who they really are.',
    whyItHelps: "Adventure stories build courage, resilience, and a sense that the world is an exciting place full of possibility. They show children that facing the unknown is not something to fear — it is something to run toward. Every adventurous bedtime story is a rehearsal for the child's own life, teaching them that the best stories always begin with a single brave step.",
    bestFor: ['Curious, energetic children', 'Children preparing for a new experience', 'Building confidence and a sense of capability', 'Parents who want to raise children who embrace challenge'],
    storyTitles: [
      'Into the Forest Nobody Had Come Back From — Until Now',
      'The Map That Led Somewhere Nobody Expected',
      'First Expedition: The Journey That Changed Everything',
      'The Explorer Who Was Only Seven — But That Was Enough',
    ],
  },
  {
    slug: 'educational', label: 'Educational', emoji: '🧠',
    description: 'Cleverly educational bedtime stories that teach real-world facts and concepts through magical adventures.',
    whyItHelps: "Educational bedtime stories are one of the most powerful learning tools available to parents — children absorb information effortlessly when it is woven into a story they love. Science, history, nature, mathematics, and social skills are all more memorable when they arrive wrapped in an adventure starring your child. Learning disguised as magic is the best kind.",
    bestFor: ['Parents who want bedtime to be both fun and enriching', 'School-age children curious about the world', 'Children interested in science, history, or nature', 'Any night when a child has come home full of questions'],
    storyTitles: [
      'The Child Who Discovered How Stars Are Born',
      'The History Lesson That Came to Life at Bedtime',
      'Why the Ocean Is Salty: A Bedtime Science Adventure',
      'The Maths Problem That Turned Out to Be a Treasure Map',
    ],
  },
  {
    slug: 'silly', label: 'Silly', emoji: '🤪',
    description: 'Wonderfully absurd bedtime stories where nothing makes sense and that is exactly the point.',
    whyItHelps: "Silly stories are pure liberation for children — a space where the rules of logic don't apply, where a dog can become the Prime Minister and the moon can ask for a cup of tea. Silliness relieves tension, sparks creativity, and gives children permission to laugh at the world and themselves. The best silly stories are completely ridiculous and completely unforgettable.",
    bestFor: ['Children with a wild, creative imagination', 'Evenings when everything needs to be a bit lighter', 'Parents who love absurdist humour', 'Any child who needs reminding that life doesn\'t have to be so serious'],
    storyTitles: [
      'The Day Everything Was Upside Down For No Reason',
      'The Queen Who Ruled a Kingdom of Cheese',
      'The Extremely Serious Meeting of All the World\'s Socks',
      'Why the Sky Is Blue (According to a Penguin Who Was Probably Wrong)',
    ],
  },
];
